export default "__VITE_ASSET__DpgyW3Hm__"